<template>
    <div class="content-body">
        <div class="container pd-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                            <!--                            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>-->
                            <!--                            <li class="breadcrumb-item active" aria-current="page">Sales Monitoring</li>-->
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">Welcome
                        <span v-if="auth.userInfo != null">
                            {{auth.userInfo.firstName}} {{auth.userInfo.lastName}}
                        </span></h4>
                </div>
                <div class="d-none d-md-block">
<!--                    <new-account-button></new-account-button>-->
                    <router-link to="/new-officer" class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="plus" class="wd-10 mg-r-5"></i> New Officer</router-link>
<!--                    <button style="background-color: #6d0606; border-color: #6d0606;" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">-->
<!--                        <download-excel-->
<!--                                class   = "lnr-cloud-download"-->
<!--                                style="cursor: pointer;"-->
<!--                                :data   = "company.company"-->
<!--                                worksheet = "My Worksheet"-->
<!--                                :name    = "$route.name+'.xls'">-->
<!--                            <span> <i data-feather="file" class="wd-10 mg-r-5"></i> Generate Report</span>-->
<!--                        </download-excel>-->
<!--                    </button>-->
                </div>
            </div>

            <!--TODO TOP CARDS-->
            <top-cards></top-cards>
            <!--TODO GROWTH-->
            <officer-details-form></officer-details-form>


        </div><!-- container -->
    </div>
</template>

<script>
    import TopCards from "../../components/card/TopCards";
    // import DetailsForm from "../../components/form/DetailsForm";
    // import {} from ''
    import OfficerDetailsForm from "../../components/form/OfficerDetailsForm";
    // import BaseTable from "../../components/table/BaseTable";
    // import NewAccountButton from "../../components/button/NewAccountButton";
    import {mapState} from 'vuex'
    export default {
        name: 'Home',
        components:{
            TopCards,
            OfficerDetailsForm,
            // NewAccountButton
        },
        data(){
            return{
                fields: [
                    { key: 'serial', label: 'S/N', sortable: true, sortDirection: 'desc' },
                    { key: 'officerFirstName', label: 'First Name', sortable: true, sortDirection: 'desc' },
                    { key: 'officerLastName', label: 'Surname', sortable: true, sortDirection: 'desc' },
                    { key: 'officerDesignation', label: 'Role', sortable: true, class: 'text-center' },
                    { key: 'officerAuthBank', label: 'Bank Verified', sortable: true, class: 'text-center' },
                    { key: 'officerAuthStatus', label: 'DIR/SIG Verified', sortable: true, class: 'text-center' },
                    { key: 'actionx', label: 'Action', sortable: true, class: 'text-center' }
                ],
            }
        },
        computed:{
            ...mapState([
                'officer',
                'auth'
            ]),

            officers:{
                get(){
                    return this.officer.officers
                },
                set(val){
                    this.$store.commit('officer/updateOfficers', val)
                }
            },
        }
    }
</script>
